/**
 *
 * @param data
 */
export function isInteger(data: string): boolean {
    return Number.isInteger(Number(data));
}
